import { RouteAnimationShared } from './../../../utils/route-animation-shared';
import { ProfileApiService } from './profile-api.service';
import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { GenericResponse, GenericResponseData } from '../generic-response';
import { DietDataService } from '../plan-repository/diet-data.service';
import { UserApiService } from '../user-repository/user-api.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(
    private location: Location,
    private router: Router,
    private dietDataService: DietDataService,
    private userApiService: UserApiService,
    private profileApiService: ProfileApiService,
    private routeAnimationShared: RouteAnimationShared
  ) {}

  goBack() {
    this.routeAnimationShared.showRouteAnimation();
    this.location.back();
  }

  goToMain() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/main/dashboard']);
  }

  goToReferral() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/referral']);
  }

  goToDietDetail() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/dietdetail']);
  }

  goToProfileWaterChart() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/profilewaterchart']);
  }

  goToProfileWeightChart() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/profileweightchart']);
  }

  getReferralUsers(): Promise<GenericResponse> {
    return this.profileApiService.getReferralUsers();
  }

  getCurrentDiet(): Promise<GenericResponse> {
    let response: GenericResponse;
    const date = new Date(new Date().setHours(0, 0, 0, 1));
    return this.dietDataService.getDiets().then((res) => {
      if (res.diets.length !== 0) {
        const diet = res.diets[0];
        const diets = [diet];
        const created = new Date(diet.createdAt).setHours(0, 0, 0, 0);
        const endDate = new Date(diet.endDate).setHours(0, 0, 0, 0);
        if (diet.startDate < date.getTime() && endDate > date.getTime()) {
          response = new GenericResponse(
            true,
            new GenericResponseData({ type: 'diet', diets })
          );
        } else if (created < date.getTime() && endDate > date.getTime()) {
          response = new GenericResponse(
            true,
            new GenericResponseData({ type: 'before', diets })
          );
        } else {
          response = new GenericResponse(false);
        }
      } else {
        response = new GenericResponse(false);
      }
      return response;
    });
  }

  // getDiets() {
  //   let response: GenericResponse;
  //   return this.dietDataService.getDiets().then((res) => {
  //     if (res.diets && res.diets.length !== 0) {
  //       response = new GenericResponse(true, new GenericResponseData({type: 'hasDiet', diets: res.diets}));
  //     } else {
  //       response = new GenericResponse(false);
  //     }
  //     return response;
  //   });
  // }

  getUser(): Promise<GenericResponse> {
    return this.userApiService.getUser();
  }
}
